import React, { useState, useCallback } from "react";
import { Popover } from "antd";
import { SketchPicker, ColorResult } from "react-color";
import styled from "styled-components";

const ColorBlock = styled.div<{ $backgroundColor: string }>`
  width: 24px;
  height: 24px;
  background-color: ${(props) => props.$backgroundColor};
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 2px;
`;

interface ColorPickerTriggerProps {
  value?: string;  // 支持 hex 或 rgba 字符串
  onChange?: (value: string) => void;
}

export const ColorPickerTrigger: React.FC<ColorPickerTriggerProps> = ({
  value = '#000000',
  onChange,
}) => {
  const [visible, setVisible] = useState(false);

  // 将颜色字符串转换为 ColorResult 对象
  const parseColor = useCallback((colorStr: string) => {
    // 检查是否是 rgba 格式
    const rgbaMatch = colorStr.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/);
    if (rgbaMatch) {
      return {
        r: parseInt(rgbaMatch[1]),
        g: parseInt(rgbaMatch[2]),
        b: parseInt(rgbaMatch[3]),
        a: rgbaMatch[4] ? parseFloat(rgbaMatch[4]) : 1
      };
    }
    
    // 如果不是 rgba，则当作 hex 处理
    return value;
  }, []);

  // 将 ColorResult 转换为颜色字符串
  const formatColor = useCallback((color: ColorResult) => {
    const { r, g, b, a } = color.rgb;
    // 如果透明度为 1，返回 hex 格式
    if (a === 1) {
      return color.hex;
    }
    // 否则返回 rgba 格式
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }, []);

  const handleColorChange = useCallback((newColor: ColorResult) => {
    onChange?.(formatColor(newColor));
  }, [onChange, formatColor]);

  return (
    <Popover
      content={
        <SketchPicker 
          color={parseColor(value)}
          onChange={handleColorChange}
        />
      }
      trigger="click"
      open={visible}
      onOpenChange={setVisible}
    >
      <ColorBlock $backgroundColor={value} />
    </Popover>
  );
};